export enum queryParams {
  VENDOR = 'vendor',
  CATEGORY = 'category',
  PAGE = 'page',
  SORT = 'sort',
  FILTER = 'filter',
  QUICK_VIEW = 'quickView',
  SIZE = 'size'
}
